import React from 'react';

const AppContext: any = React.createContext({});

export default AppContext;
